import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

export const phoneFields = [
  { label: 'Brand', key: 'brand', validation: { required: true } },
  { label: 'Model', key: 'model', validation: { required: true } },
  { label: 'Product Price Toman', key: 'price', type: 'number' },
  {
    label: 'Picture',
    key: 'picture',
    type: 'image',
    purpose: 'phone_picture',
    validation: { required: false },
  },
  //   {
  //     label: 'شماره سریال‌ها(در هر خط یک شماره قرار دهید)',
  //     mod: 'add',
  //     key: 'warranty_numbers',
  //     type: 'multiline',
  //     validation: { required: true },
  //     placeholder: `GPM0201
  // GPM0202
  // GPM0203

  //   `
  //   }
];
const PhoneForm = () => {
  return (
    <CrudGridForm path={apiPaths.PHONES} name="Phone" entityName={'phones'} fields={phoneFields} />
  );
};

export default PhoneForm;
